import BoonButterflyIcon from '@assets/svg/boon-butterfly.svg';
import Modal from '@common/modal/modal';
import ModalState from '@redux/modal/modal-state.interface';
import { hideModal } from '@root/src/redux/modal/modal-dispatcher';
import * as Sentry from '@sentry/browser';
import { userService } from '@services/user/user-service';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import ForgotPasswordForm from '../../auth/forgot-password-form';
import BoonButton from '../../button/boon-button';
import styles from './forgot-password-modal.styles';

const ForgotPasswordModal: React.FC = () => {
    const { t } = useTranslation();
    const [invalidEmail, showInvalidEmail] = useState(false);
    const [showGenericError, setGenericErrorShow] = useState(false);
    const [successMessage, showSuccessMessage] = useState(false);
    const show = useSelector((state: { modal: ModalState }) => state.modal.show);

    useEffect(() => {
        showInvalidEmail(false);
        setGenericErrorShow(false);
        showSuccessMessage(false);
    }, [show]);

    const onClickSubmit = () => {
        setGenericErrorShow(false);
        showInvalidEmail(false);
    };

    const onSubmit = async (email: string) => {
        try {
            setGenericErrorShow(false);
            showInvalidEmail(false);
            await userService.forgotPassword(email);
            showSuccessMessage(true);
        } catch (error) {
            if (error.response && typeof error.response.status !== 'undefined' && error.response.status === 404) {
                showInvalidEmail(true);
            } else {
                setGenericErrorShow(true);
                Sentry.captureException(error);
            }
        }
    };

    return (
        <Modal id="forgot-password" width="w-96">
            {successMessage ? (
                <div className="ForgotPasswordSuccessContainer text-center text-black text-sm font-gr-book">
                    <img
                        width="50"
                        className="absolute inline-block py-2 right-0 left-0 mr-auto ml-auto top-12"
                        src={BoonButterflyIcon}
                    />
                    <p className="text-xl mt-12 mb-2 text-center text-charcoal">
                        {t('base:forgot-password-success-header')}
                    </p>
                    <p className="label text-ashgray text-center py-2 text-xs px-8">
                        {t('base:forgot-password-success-content')}
                    </p>
                    <BoonButton
                        style="dark"
                        height="h-10"
                        width="w-32"
                        type="link"
                        onClick={() => hideModal('forgot-password')}
                        font="text-white uppercase font-bold text-xs"
                        addtlContainerClasses="ConfirmLogoutButton"
                    >
                        {t('base:forgot-password-submit')}
                    </BoonButton>
                </div>
            ) : (
                <React.Fragment>
                    <style jsx>{styles}</style>
                    <img
                        width="50"
                        className="absolute inline-block py-2 right-0 left-0 mr-auto ml-auto top-12"
                        src={BoonButterflyIcon}
                    />

                    <ForgotPasswordForm onSubmit={onSubmit} onClickSubmit={onClickSubmit} />
                    {(invalidEmail || showGenericError) && (
                        <span className={'ErrorMessage w-full pr-2 block text-center text-red text-xs leading-6'}>
                            {invalidEmail && <React.Fragment>{t('validation:non-existing-email')}</React.Fragment>}
                            {showGenericError && <React.Fragment>{t('validation:error-generic')}</React.Fragment>}
                        </span>
                    )}
                </React.Fragment>
            )}
        </Modal>
    );
};

export default ForgotPasswordModal;
